import styled from "styled-components"

const Menu = styled.div`
  display: grid;
  justify-self: end;
  grid-auto-flow: column;
`

export default Menu